import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { STEPS_CONFIG_PATH } from "utils/constants/paths";

const StepsConfig = Loadable(React.lazy(() => import("./View/index")));

export const StepsConfigRoute: IRouteItem = {
  path: STEPS_CONFIG_PATH,
  element: React.createElement(StepsConfig),
  accessKeys: ["Support", "ContentCreator", "Analyst", "SystemUserManager"],
  name: "Steps Config",
  iconName: "Drop",
};
